// extracted by mini-css-extract-plugin
module.exports = {"markdownBody":"BlogModal_markdownBody__zb2V_","friendLinksScope":"BlogModal_friendLinksScope__QsqTv"};